(function (once) {
  Drupal.behaviors.imageMapBehavior = {
    attach: function (context, settings) {
      once('imageMapBehavior', 'div.field--name-field-map', context).forEach(
        function (element) {
          const draggable = element.querySelector('.field__item');
          let isDragging = false;
          let initialX = 0,
            initialY = 0,
            startX = 0,
            startY = 0,
            dragX = 0,
            dragY = 0;

          draggable.addEventListener('mousedown', (e) => {
            console.log('mousedown');
            isDragging = true;
            startX = e.clientX;
            startY = e.clientY;
            draggable.style.cursor = 'grabbing';
          });

          draggable.addEventListener('mouseup', () => {
            isDragging = false;
            initialX = dragX;
            initialY = dragY;
            draggable.style.cursor = 'grab';
          });

          draggable.addEventListener('mousemove', (e) => {
            if (!isDragging) return;
            const newX = startX - e.clientX + initialX;
            const newY = startY - e.clientY + initialY;
            console.log('new', newX, newY);

            const maxX =
              (draggable.clientWidth - draggable.parentElement.clientWidth) / 2;
            const maxY =
              (draggable.clientHeight - draggable.parentElement.clientHeight) /
              2;

            if (newX < maxX && newX > -maxX) {
              dragX = newX;
              draggable.style.left = `calc(50% - ${dragX}px)`;
            }

            if (newY < maxY && newY > -maxY) {
              dragY = newY;
              draggable.style.top = `calc(50% - ${dragY}px)`;
            }
          });

          const expandButton = element.parentElement.querySelector('.expand');
          const modal = element.parentElement.querySelector(
            '.map-modal--content'
          );
          const image = draggable.querySelector('img');
          expandButton.addEventListener('click', (e) => {
            document.body.classList.toggle('modal');
            element.parentElement.classList.toggle('expand');
            modal.appendChild(image.cloneNode(true));
          });

          const closeButtton = element.parentElement.querySelector('.close');
          closeButtton.addEventListener('click', (e) => {
            document.body.classList.toggle('modal');
            element.parentElement.classList.toggle('expand');
            modal.innerHTML = '';
          });
        }
      );
    },
  };
})(once);
